import * as React from "react";

import "./admin-ad-budgets-route.scss";

import {cs}                             from "@Common/react/chain-services";
import {consumeContext}                 from "@Common/react/context";
import {KeyLoader2}                     from "@Common/react/key-loader-2";
import {Load}                           from "@Common/react/load";
import {UseState}                       from "@Common/react/use-state";
import {ConfirmDialog}                  from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";
import {needsConfirmation}              from "@Common/ui-components/needs-confirmation/needs-confirmation";
import {Responsive}                     from "@Common/ui-components/responsive";
import {BRANCH_LEVEL}                   from "@Xpresso/routes/common/logic/user-level";
import {COMPANY_LEVEL}                  from "@Xpresso/routes/common/logic/user-level";
import {AccountingLayout}               from "../common/accounting-layout";
import {LimitedOfficeSelect}            from "../common/limited-office-select/limited-office-select";
import {UpdateAmountForm}               from "../common/update-amount-form/update-amount-form";
import {AgentSelect}                    from "./agent-select/agent-select";
import {Table}                          from "./table/table";
import {AdminAdBudgetCardContainer}     from "./admin-ad-budget-card-container/admin-ad-budget-card-container";

export const AccountAdminAdBudgetsRoute = () => cs(
    consumeContext("apis"),
    consumeContext("session"),
    consumeContext("userLevels"),
    ({}, next) => AccountingLayout({activeTab: "admin-ad-budgets", next}),
    ["branchList", ({apis}, next) => Load({
        fetch: () => apis.next.getBranchList(),
        next,
    })],
    ["selectedBranches", ({session, userLevels}, next) => UseState({
        initValue: userLevels.userLevel === BRANCH_LEVEL ? [{idBranch: session.value?.branchId}] : [],
        next,
    })],
    ["agentList", ({apis, userLevels, session, selectedBranches}, next) => KeyLoader2({
        keys: selectedBranches.value?.map((b) => b.idBranch),
        load: (idBranch) => userLevels.userLevel === COMPANY_LEVEL ? (
            apis.next.getAgentList(idBranch)
        ) : (
            apis.next.getAgentList(session.value.branchId)
        ),
        next,
    })],
    ["selectedAgents", (_, next) => UseState({
        initValue: [],
        next,
    })],
    ["responsive", ({}, next) => <Responsive {...{
        sizes: {
            md: 1024,
        },
        next,
    }}/>], 
    ({apis, userLevels, branchList, selectedBranches, agentList, selectedAgents, responsive}) => (
        <div className="admin-ad-budgets-route-19l">
            <div className="header">
                <div className="left">
                    {userLevels.userLevel === COMPANY_LEVEL && 
                    LimitedOfficeSelect({
                        branchList,
                        selectedBranches,
                    })}
                    {AgentSelect({
                        branches: selectedBranches.value,
                        getAgentList: agentList.getValue,
                        selectedAgents,
                    })}
                </div>

                <div className="right">
                    {cs(
                        ["confirm", ({}, next) => cs(
                            ["dialog", ({}, next) => ConfirmDialog({next})],
                            ({dialog}) => next(async () => {
                                return await needsConfirmation({
                                    confirmDialog: dialog,
                                    message: "Update Selected User(s) Ad Budgets",
                                    actionName: "update"
                                })
                            }),
                        )],
                        ({confirm}) => UpdateAmountForm({
                            disabled: !selectedAgents.value.some((a) => a.allow),
                            onChange: async (v) => {
                                if (await confirm()) {
                                    selectedAgents.change((bs) => bs.map((b1) => ({
                                        ...b1,
                                        amount: b1.allow ? v : b1.amount,
                                    })));
                                    selectedAgents?.value.map(async (b) => {
                                        b.allow && await apis.next.adBudgets.setUserAdBudget({
                                            idBranch: b.agent.idBranch,
                                            list: [{
                                                idAgent: b.agent.idAgent,
                                                amount: v,
                                                status: b.allow,
                                            }],
                                        })
                                    })
                                }
                            },
                        }),
                    )}

                </div>
            </div>

            <div className="box">
                {responsive.ge("md") ? (
                        Table({budgets: selectedAgents})
                    ) : (
                        AdminAdBudgetCardContainer({selectedAgents})
                    )
                }
            </div>

        </div>
    ),
);

export const pageSizesAdminAdBudget = [5, 10, 20]
export const helperTextAdminAdBudget = 'NOTE: To modify a budget amount, make sure the user has Ad Budgets "allowed"'
